/**
 * Corrige a razão social no cadastro do cliente da NF-e.
 * A DANFE autorizada permanece com o nome enviado à SEFAZ.
 */

import { useEffect, useState } from 'react'
import { AlertTriangle } from 'lucide-react'
import Modal from '../Modal/Modal'
import './NFeCancelModal.css'

export const RAZAO_SOCIAL_CANCEL_JUSTIFICATION =
  'Razão social do destinatário informada incorretamente no cadastro.'

function NFeCorrigirRazaoSocialModal({
  isOpen,
  onClose,
  onConfirm,
  onRequestCancel,
  nfe,
  loading = false
}) {
  const currentName = nfe?.customer_name || ''
  const [name, setName] = useState(currentName)
  const [error, setError] = useState('')
  const [saved, setSaved] = useState(false)

  useEffect(() => {
    if (!isOpen) return
    setName(nfe?.customer_name || '')
    setError('')
    setSaved(false)
  }, [isOpen, nfe])

  const handleConfirm = async () => {
    const nextName = name.trim()
    if (nextName.length < 2) {
      setError('Informe a razão social correta.')
      return
    }
    if (nextName === currentName.trim()) {
      setError('A razão social informada é a mesma do cadastro atual.')
      return
    }
    setError('')
    const ok = await onConfirm(nextName)
    if (ok) setSaved(true)
  }

  const handleClose = () => {
    if (loading) return
    onClose()
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Corrigir razão social"
      size="medium"
    >
      <div className="nfe-cancel-modal">
        <div className="cancel-warning">
          <AlertTriangle size={24} />
          <div>
            <h3>A DANFE já autorizada não muda</h3>
            <p>
              A correção atualiza o cadastro do cliente. A nota já enviada à SEFAZ continua com o nome da emissão.
              Carta de correção não altera a razão social do destinatário.
            </p>
            <p>
              Para o cliente receber o documento com o nome certo, cancele esta NF-e dentro do prazo e emita outra.
              A nova emissão usa a razão social corrigida.
            </p>
            {nfe && (
              <p className="nfe-info">
                <strong>NF-e #{nfe.number}</strong>
                {currentName ? ` · Cadastro atual: ${currentName}` : ''}
              </p>
            )}
          </div>
        </div>

        {!saved ? (
          <div className="form-field">
            <label htmlFor="razao-social">
              Razão social correta <span className="required">*</span>
            </label>
            <input
              id="razao-social"
              value={name}
              onChange={(event) => {
                setName(event.target.value)
                setError('')
              }}
              maxLength={255}
              disabled={loading}
              className={error ? 'error' : ''}
            />
            {error && <span className="error-message">{error}</span>}
          </div>
        ) : (
          <p className="help-text">
            Cadastro atualizado para <strong>{name.trim()}</strong>.
          </p>
        )}

        <div className="modal-footer">
          <button className="btn-secondary" type="button" onClick={handleClose} disabled={loading}>
            Fechar
          </button>
          {!saved ? (
            <button className="btn-primary" type="button" onClick={handleConfirm} disabled={loading}>
              {loading ? 'Salvando...' : 'Salvar razão social'}
            </button>
          ) : (
            <button className="btn-primary" type="button" onClick={onRequestCancel} disabled={loading}>
              Cancelar esta NF-e
            </button>
          )}
        </div>
      </div>
    </Modal>
  )
}

export default NFeCorrigirRazaoSocialModal
